import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { createCampaignTabs } from "./GoogleAutomationConstants";
import CreateCampaignTemplate from "./CreateCampaignTemplate";

const LayoutFacebookAutomation = ({ creationRandomId }) => {
  const [activeStep, setActiveStep] = useState(1);
  const handleStep = (step) => {
    setActiveStep(step);
  };

  return (
    <div className="overflow-hidden h-[451px]">
      <div className="flex   gap-10">
        <div className="flex flex-col gap-2">
          <div>
            <span
              style={{ fontWeight: "bold", fontSize: "24px", color: "black" }}
            >
              AD Manage
            </span>
            <span
              style={{
                fontWeight: "normal",
                fontSize: "24px",
                color: "blue",
                marginLeft: "4px",
              }}
            >
              Plus
            </span>
          </div>
          <Sidebar
            step={activeStep}
            setStep={handleStep}
            navigationTabs={createCampaignTabs}
          />
        </div>
        <div className="w-full">
          <div className="flex flex-col gap-2 mb-5">
            <span
              style={{ fontWeight: "bold", fontSize: "24px", color: "black" }}
            >
              Create Campaign{" "}
            </span>
          </div>
          <div className="w-full ">
            <CreateCampaignTemplate
              currentStep={activeStep}
              nextStep={handleStep}
              creationRandomId={creationRandomId}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutFacebookAutomation;
